import React from 'react';
import { observer } from 'mobx-react';
import { Link, useLocation } from 'react-router-dom';
import { useStores } from 'stores';
import styles from './NotFound.module.scss';

const NotFound = () => {
  const {
    spinnerStore: { isSpinning },
  } = useStores();
  const location = useLocation();
  if (isSpinning || location.pathname === '/') {
    return null;
  }
  return (
    <div className={styles.bns3_not_found_page_container}>
      <h1 className={styles.bns3_not_found_page_title}>Oops...404</h1>
      <h2 className={styles.bns3_not_found_page_subtitle}>Page Not Found</h2>
      <p className={styles.bns3_not_found_page_text}>
        You can return to
        <Link to="/" className={styles.bns3_not_found_page_link}>
          Home Page
        </Link>
      </p>
    </div>
  );
};

export default observer(NotFound);
